import { API_CUSTOMER_MENU_URL } from '@/constants/config';
import { MenuResponse } from '@/interfaces/Menu';
import { fetch } from '@/utils/fetch';

export const getBranchMenus = (
  brandId: string,
  kitchenId: string,
  pointOfSaleId: string,
  language?: string
): Promise<MenuResponse> =>
  fetch
    .get<MenuResponse>(
      `${API_CUSTOMER_MENU_URL}/branch-menus/?brand-id=${brandId}&kitchen-id=${kitchenId}&point-of-sale-id=${pointOfSaleId}&language=${language}`
    )
    .then(response => response.data);
